export default __webpack_public_path__ + "static/jetson_product_2-d0cf0f21a6ee9b05bc077eed0f3f07e1.png";